import React, { useContext, useEffect, useState } from 'react';
import { Button, Spinner } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom'

import { Title } from '../../Components/Atoms'

import { StoreContext } from '../../Library/contexts'
import PATHS from "../../Routes/paths";

import { ArrowRightIcon } from '../../Assets/images/svgs'
import { getFomattedAmt } from '../../Library/helpers'

import "./style.css"

const PayStatCard = ({data}) => {
  return (
    <article className="widget-main">
      <header className="widget-header">
        <Title variant="md" fixed>{data.heading}</Title>
      </header>

      <main className="widget-section">
        <div className="widget-chart">
          <span className='widget-chart-icon payment-stats-card-content' style={{borderColor: data.color}}>
            <h1 className='payment-stats-card-amt'>{data.amount}</h1>
          </span>
        </div>
      </main>
    </article>
  )
}

const PaymentStats = () => {
  const [ShowPaymentWidget, setShowPaymentWidget] = useState(false);
  const { constants, filters } = useContext(StoreContext);

  const [paymentData, setPaymentData] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const handlePaymentWidgets = (eventData) => {
      if(eventData.clientId === -1){
        setShowPaymentWidget(false);
        return;
      }
      let client = constants.clientMap[eventData.clientId];
      const data = [
        {
          heading: "Actual Amount",
          amount: getFomattedAmt(client.amt),
          color: "#409BFF",
        },
        {
          heading: "Received Amount",
          amount: getFomattedAmt(client.rcvdAmt),
          color: "#2AC670",
        },
        {
          heading: "Outstanding Amount",
          amount: getFomattedAmt(client.outsdAmt),
          color: "#BD4620",
        }
      ];
      setPaymentData(data);
      setShowPaymentWidget(true);
    }

    global.EE.addEventListener(global.EE.EVENT_TYPES.LEASED_VEHICLES_FETCHED, handlePaymentWidgets)

    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.LEASED_VEHICLES_FETCHED, handlePaymentWidgets)
    }
    
  }, [filters, constants])
  

  if (!ShowPaymentWidget) return null;

  return (
    <div className='payment-stats'>
      {paymentData ? (
        <div className="widget-group widget-3 payment-stats-cards-container">
          {paymentData.map((data, i) => (<PayStatCard key={i} data={data} />))}
        </div>
        ) : (
          <div className="add-model-loader">
            <Spinner />
          </div>
        )}
      <div className="widget-link payment-stats-view-report">
        <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.PAYMENTS)}>
          View Reports
        </Button>
      </div>
    </div>
  )
}

export default PaymentStats